import React, { Component } from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import "./css/app.css";
import "bootstrap/dist/css/bootstrap.min.css";
import AccessDeniedPage from "./pages/error-pages/access-denied.page";
import NotFoundPage from "./pages/error-pages/not-found.page";
import ServiceUnavailable from "./pages/error-pages/service-unavailable.page";
import TermsOfService from "./pages/legal/terms-of-service.page";
import PrivacyPolicyPage from "./pages/legal/privacy-policy.page";
import HomePage from "./pages/homepage.page";
import ProjectOverViewPage from "./pages/project-overview.page";
import AboutMePage from "./pages/about.page";
import MyExperiencePage from "./pages/experience.page";
import ContactPage from "./pages/contact.page";
import ProjectsPage from "./pages/projects.page";
import reportVisitService from "./reporting-visit/report-visit.service";

class App extends Component {
  componentDidMount() {
    reportVisitService.report(window.location.pathname, document.title);
  }

  componentDidUpdate() {
    reportVisitService.report(window.location.pathname, document.title);
  }
  render() {
    return (
      <div id="pageContentWrapper">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutMePage />} />
          <Route path="/experience" element={<MyExperiencePage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/projects" element={<ProjectsPage />} />
          <Route path="/error/access-denied" element={<AccessDeniedPage />} />
          <Route path="/error/not-found" element={<NotFoundPage />} />
          <Route
            path="/error/service-unavailable"
            element={<ServiceUnavailable />}
          />
          <Route path="/legal/terms-of-service" element={<TermsOfService />} />
          <Route path="/legal/privacy-policy" element={<PrivacyPolicyPage />} />
          <Route
            path="/projects/:projectName"
            element={<ProjectOverViewPage />}
          />
          <Route path="*" element={<Navigate to="/error/not-found" />} />
        </Routes>
      </div>
    );
  }
}

export default App;
